import * as types from './types'
import { createReducer } from 'app/state/utils'
export interface SubTradeState {
  subTrades: any[]
  subTrade?: any
  lockedSubTrades: any[]
  isLoading: boolean
}

const initialState: SubTradeState = {
  subTrades: [],
  subTrade: undefined,
  lockedSubTrades: [],
  isLoading: false,
}

const subTradesReducer = createReducer(initialState)({
  [types.GET_SUB_TRADES]: (state: any, payload: any) => {
    return { ...state, subTrades: payload.payload }
  },
  [types.GET_SUB_TRADE]: (state: any, payload: any) => {
    return { ...state, subTrade: payload.payload }
  },
  [types.ADD_SUB_TRADES]: (state: any, payload: any) => {
    return {
      ...state,
      subTrades: [{ ...payload.payload }, ...state.subTrades],
    }
  },
  [types.EDIT_SUB_TRADES]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...payload.payload }
    if (state?.subTrade?.id === payload?.payload?.id) {
      return {
        ...state,
        subTrades: newArray,
        subTrade: { ...payload.payload },
      }
    }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.GET_LOCKED_SUB_TRADES]: (state: any, payload: any) => {
    return { ...state, lockedSubTrades: payload.payload }
  },
  [types.DELETE_SUB_TRADE]: (state: any, payload: any) => {
    if (!payload.payload || payload.payload.length === 0) {
      return state
    }
    const deletedIds = payload.payload
      .filter((payload: any) => !payload.error)
      .map((payload: any) => payload.id)
    return {
      ...state,
      subTrades: state.subTrades.filter(
        (subTrade: any) => !deletedIds.includes(subTrade.id),
      ),
      subTrade:
        state.subTrade && deletedIds.includes(state.subTrade.id)
          ? null
          : state.subTrade,
    }
  },
  [types.START_LOADING_SUB_TRADES]: (state: SubTradeState) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_SUB_TRADES]: (state: SubTradeState) => {
    return { ...state, isLoading: false }
  },
  [types.ADD_SUB_TRADE_FEE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...payload.payload }
    if (state?.subTrade?.id === payload?.payload?.id) {
      return {
        ...state,
        subTrades: newArray,
        subTrade: { ...payload.payload },
      }
    }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.EDIT_SUB_TRADE_FEE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...payload.payload }
    if (state?.subTrade?.id === payload?.payload?.id) {
      return {
        ...state,
        subTrades: newArray,
        subTrade: { ...payload.payload },
      }
    }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.ADD_LOCKED_SUB_TRADE_FEE]: (state: any, payload: any) => {
    const updated = {
      ...payload.payload.subTrade,
      status: payload.payload.status,
      lockedDate: payload.payload.effectiveDate,
    }

    const subTradeIndex = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === updated.id,
    )
    const lockedIndex = state.lockedSubTrades.findIndex(
      (subTrade: { subTrade: { id: any } }) =>
        subTrade.subTrade.id === updated.id,
    )

    const newSubTrades = [...state.subTrades]
    newSubTrades[subTradeIndex] = updated

    const newLockedSubTrades = [...state.lockedSubTrades]
    if (lockedIndex !== -1) {
      newLockedSubTrades[lockedIndex] = {
        ...state.lockedSubTrades[lockedIndex],
        subTrade: updated,
      }
    }

    return {
      ...state,
      subTrades: newSubTrades,
      lockedSubTrades: newLockedSubTrades,
      subTrade: state?.subTrade?.id === updated.id ? updated : state.subTrade,
    }
  },
  [types.EDIT_LOCKED_SUB_TRADE_FEE]: (state: any, payload: any) => {
    const updated = {
      ...payload.payload.subTrade,
      status: payload.payload.status,
      lockedDate: payload.payload.effectiveDate,
    }

    const subTradeIndex = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === updated.id,
    )
    const lockedIndex = state.lockedSubTrades.findIndex(
      (subTrade: { subTrade: { id: any } }) =>
        subTrade.subTrade.id === updated.id,
    )

    const newSubTrades = [...state.subTrades]
    newSubTrades[subTradeIndex] = updated

    const newLockedSubTrades = [...state.lockedSubTrades]
    if (lockedIndex !== -1) {
      newLockedSubTrades[lockedIndex] = {
        ...state.lockedSubTrades[lockedIndex],
        subTrade: updated,
      }
    }

    return {
      ...state,
      subTrades: newSubTrades,
      lockedSubTrades: newLockedSubTrades,
      subTrade: state?.subTrade?.id === updated.id ? updated : state.subTrade,
    }
  },
  [types.DELETE_SUB_TRADE_FEE]: (
    state: { subTrades: any[] },
    action: { payload: any },
  ) => {
    const { payload } = action
    if (!payload) {
      return state
    }

    // Find the subTrade matching the payload id
    const subTradeIndex = state.subTrades.findIndex(
      subTrade => subTrade.id === payload.id,
    )

    // If no matching subTrade is found, return state as is
    if (subTradeIndex === -1) {
      return state
    }

    const { fees } = state.subTrades[subTradeIndex]

    // Filter out fees that match the feeType to be deleted
    const updatedFees = fees.filter(
      (fee: { feeType: string }) => fee.feeType !== payload.feeType,
    )

    // Update the subTrades array immutably
    const updatedSubTrades = state.subTrades.map((subTrade, index) =>
      index === subTradeIndex ? { ...subTrade, fees: updatedFees } : subTrade,
    )

    return {
      ...state,
      subTrades: updatedSubTrades,
      subTrade: fees.filter(
        (fee: { feeType: string }) => fee.feeType === payload.feeType,
      ),
    }
  },
  [types.CHANGE_ALLOCATION_SUB_TRADE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...payload.payload }
    if (state?.subTrade?.id === payload?.payload?.id) {
      return {
        ...state,
        subTrades: newArray,
        subTrade: { ...payload.payload },
      }
    }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.CHANGE_WIRE_INSTRUCTION_SUB_TRADE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...payload.payload }
    if (state?.subTrade?.id === payload?.payload?.id) {
      return {
        ...state,
        subTrades: newArray,
        subTrade: { ...payload.payload },
      }
    }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.UPDATE_SUB_TRADE_CLIENT_ID]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = { ...newArray[index], clientId: payload.payload.clientId }
    return {
      ...state,
      subTrades: newArray,
    }
  },
  [types.ADD_TEMPORARY_SUB_TRADE]: (state: any, payload: any) => {
    return {
      ...state,
      subTrades: [
        ...state.subTrades,
        {
          facilityIds: payload.payload.facilityIds,
          sellerId: {
            id: payload.payload.entityId,
            admin: payload.payload.entityId.admin,
          },
          masterTradeId: payload.payload.masterTradeId,
          id: payload.payload.subTradeId,
          agencyAdmin: payload.payload.entityId.admin,
          buyerWireInstructions: [],
          sellerWireInstructions: [],
        },
      ],
    }
  },
  [types.SETTLE_SUB_TRADE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = {
      ...newArray[index],
      status: payload.payload.status,
      lockedDate: payload.payload.effectiveDate,
    }
    return {
      ...state,
      subTrades: newArray,
      subTrade: { ...payload.payload },
    }
  },
  [types.TERMINATE_SUB_TRADE]: (state: any, payload: any) => {
    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === payload.payload.id,
    )
    const newArray = [...state.subTrades]
    newArray[index] = {
      ...newArray[index],
      status: payload.payload.status,
      lockedDate: payload.payload.effectiveDate,
      terminationComment: payload.payload.terminationComment,
    }
    return {
      ...state,
      subTrades: newArray,
      subTrade: { ...payload.payload },
    }
  },
  [types.UNSETTLE_SUB_TRADE]: (state: any, payload: any) => {
    const id = payload.payload?.id
    const newSubTrade =
      state.subTrade && state.subTrade.id === id
        ? { ...state.subTrade, status: 'Open', lockedDate: undefined }
        : state.subTrade

    const index = state.subTrades.findIndex(
      (subTrade: { id: any }) => subTrade.id === id,
    )
    const newArray = [...state.subTrades]
    
    if (index != -1) {
      newArray[index] = {
      ...newArray[index],
      status: "Open",
      lockedDate: undefined,
    }
    }
    return {
      ...state,
      lockedSubTrades: state.lockedSubTrades.filter(
        (lockedSubTrade: { id: any }) => lockedSubTrade.id !== id,
      ),
      subTrades: newArray,
      subTrade: newSubTrade,
    }
  },
})

export default subTradesReducer
